/* eslint-disable */
export const COLUMNS = [
  {
    value: "seNumber",
    text: "SE-Number",
    isDesktop: false,
    sortable: true,
    cell: (service) => ({
      text: `${service.serviceId}`,
      value: `${service.serviceId}`
    })
  },
  {
    value: "service",
    text: "Service",
    onMobile: true,
    onTablet: true,
    sortable: true,
    cell: (service) => ({
      text: `<strong class="block font-sans leading-snug subpixel-antialiased text-base text-black font-semibold">${service.tradingAsName || service.serviceName}</strong> ${service.addresslineOne}, ${service.suburb}`,
      value: `${service.tradingAsName} ${service.addresslineOne} ${service.suburb}`
    })
  }
];

export const SETTINGS = {
  multiSelect: false,
  rowActions: false,
  contextAction: false
};

export const ACTIONS = [
  {
    label: "Educators",
    icon: "delete",
    action: "action:users",
    inHeader: false,
    allowFor: ["admin"]
  }
];